import { passThroughTranslation } from '@colonist/i18n';
import { BaseRankedUserState, RankedUserStateType } from './BaseRankedUserState.ts';
import { RankedDivisionState } from './RankedDivisionState.ts';
export class RankedMMRState extends BaseRankedUserState {
    getEndGameScreenText() {
        const title = passThroughTranslation(`${this.currentMMR}`);
        const description = {
            key: 'strings:colonistCommon.utils.emptyString'
        };
        return {
            title: title,
            description: description
        };
    }
    getEndGameScreenMMRChangeText() {
        const showPlus = '+';
        const showMinus = '';
        const mathSymbol = this.mostRecentChangeInValue > 0 ? showPlus : showMinus;
        return {
            key: 'strings:game.endGame.rankedUpdate.rating',
            options: {
                ratingChange: `${mathSymbol}${this.mostRecentChangeInValue}`
            }
        };
    }
    getEndGameData() {
        const showPlus = this.mostRecentChangeInValue > 0 ? '+' : '';
        const endGameData = {
            amount: `${showPlus}${this.mostRecentChangeInValue}`,
            highest: false
        };
        return endGameData;
    }
    getFindGamePopupStatusText() {
        return {
            key: 'strings:colonistCommon.rankedState.rating',
            options: {
                rating: this.currentMMR
            }
        };
    }
    static deserialize(data) {
        const previousDivisionState = RankedDivisionState.deserialize(data.previousDivisionState);
        const currentDivisionState = RankedDivisionState.deserialize(data.currentDivisionState);
        const newRankedState = new RankedMMRState(data.userStatCategory, data.previousMMR, data.currentMMR, previousDivisionState, currentDivisionState, data.promotionDemotionText);
        return newRankedState;
    }
    constructor(userStatCategory, previousMMR, currentMMR, previousDivisionState, currentDivisionState, promotionDemotionText){
        super(), this.type = RankedUserStateType.Ranked;
        this.userStatCategory = userStatCategory;
        this.mostRecentChangeInValue = Math.round(currentMMR - previousMMR);
        this.promotionDemotionText = promotionDemotionText;
        this.previousMMR = Math.round(previousMMR);
        this.currentMMR = Math.round(currentMMR);
        this.currentDivisionState = currentDivisionState;
        this.previousDivisionState = previousDivisionState;
    }
}
